import styled from '@emotion/styled';

import { CloseButton } from '../../../../../../components/Button/components/CloseButton';

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  opacity: 1;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: calc(100% - 2 * var(--spacing-16));
  max-width: 420px;
  padding: 16px;
  border-radius: var(--border-radius-m);
  background-color: var(--color-white);
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
`;

export const StyledCloseButton = styled(CloseButton)`
  align-self: flex-end;
`;

export const Header = styled.span`
  font: var(--font-heading-5);
  color: var(--color-black);
  margin: var(--spacing-8) var(--spacing-16) 0 var(--spacing-16);
  text-align: center;

  @media (min-width: 600px) {
    margin-left: var(--spacing-24);
    margin-right: var(--spacing-24);
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--spacing-16);
  margin: var(--spacing-32) var(--spacing-16);

  @media (min-width: 600px) {
    margin-left: var(--spacing-24);
    margin-right: var(--spacing-24);
  }
`;

export const Alert = styled.div`
  background: var(--color-success-light);
  padding: var(--spacing-24) var(--spacing-16);
  font: var(--font-body-l-bold);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-8);
  color: var(--color-black);
  border-radius: var(--border-radius-m);

  @media (min-width: 600px) {
    padding-left: var(--spacing-24);
    padding-right: var(--spacing-24);
  }
`;

export const ViewLink = styled.a`
  font: var(--font-link-xl);
  color: inherit;
`;

export const Field = styled.div`
  width: 100%;
`;

export const Label = styled.label`
  font: var(--font-body-l-bold);
`;

export const UnauthorizedAlert = styled.div`
  background: var(--color-information-light);
  width: 100%;
  border-radius: var(--border-radius-m);
  padding: var(--spacing-16) var(--spacing-12);
  display: flex;
  gap: var(--spacing-8);
  font: var(--font-body-m-light);
`;

export const UnauthorizedAlertContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);
`;

export const UnauthorizedAlertHeader = styled.header`
  font: var(--font-body-m-bold);
`;
